module.exports = __webpack_public_path__ + "static/media/Master-Typicle-mobile.fb12fdf0.webp";